import { useQuery } from '@tanstack/vue-query'
import gql from 'graphql-tag'
import { useGqlMikro } from '~/composables/useGqlMikro'

export const COLLECTS_WITH_MISSING_FIELDS_QUERY_KEY = () => ['collects-with-missing-fields']

export function useCollectsWithMissingFields() {
  const { query } = useGqlMikro()

  return useQuery({
    queryKey: COLLECTS_WITH_MISSING_FIELDS_QUERY_KEY(),
    queryFn: async () => {
      const { data, errors } = await query({
        query: COLLECTS_WITH_MISSING_FIELDS,
        variables: { pagination: { limit: 100, offset: 0 } },
      })

      if (errors && errors.length > 0) {
        throw errors
      }

      return data.collectsWithMissingFields
    },
    select(data) {
      return JSON.parse(JSON.stringify(data))
    },
  })
}

const COLLECTS_WITH_MISSING_FIELDS = gql`
query CollectsWithMissingFields {
  collectsWithMissingFields {
    licensePlate
    createdAt
    id
    startsAt
    endsAt
    collectedContainers {
      collection {
        quantity
        unit
        id
        treatmentCode
        documents {
          collection {
            id
            signedUrl
          }
        }
        container {
          id
          name
          material {
            id
            name
          }
        }
      }
    }
    client { 
      id
      name
    }
  }
}
`
